var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraphicEq = function SvgGraphicEq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.375 17.558V6.442h1.5v11.116zM11.25 21.5v-19h1.5v19zM3.5 13.654v-3.308H5v3.308zm11.625 3.904V6.442h1.5v11.116zM19 13.654v-3.308h1.5v3.308z"
  })));
};
export default SvgGraphicEq;